import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLoader } = FiIcons;

const LoadingFallback = () => {
  return (
    <div 
      className="min-h-screen flex flex-col items-center justify-center bg-slate-50 dark:bg-slate-900"
      role="status"
      aria-live="polite"
      aria-label="Loading page content"
    >
      <div className="text-center">
        <SafeIcon 
          icon={FiLoader} 
          className="w-12 h-12 animate-spin text-slate-400 dark:text-slate-600 mx-auto mb-4"
          aria-hidden="true"
        />
        <p className="text-slate-600 dark:text-slate-400 font-medium">
          Loading...
        </p>
      </div>
    </div>
  );
};

export default LoadingFallback;